"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFunctionOpcodeTemplates = getFunctionOpcodeTemplates;
function getFunctionOpcodeTemplates() {
    return `
                        case opMap[105]: { // SUPER_CALL
                            let superArgCount = stack.pop();
                            let superArgs = collectArgs(stack, superArgCount);
                            let SuperClass = stack.pop();

                            if (arg === 1) {
                                stack.push(superArgs);
                                pc++;
                                break;
                            }

                            if (typeof SuperClass !== 'function') {
                                throw new TypeError('Super expression must be a constructor');
                            }

                            {vmGlobalsName}['__$$newTarget$$__'] = newTarget;
                            try {
                                SuperClass.apply(_this, superArgs);
                            } finally {
                                delete {vmGlobalsName}['__$$newTarget$$__'];
                            }
                            pc++;
                            break;
                        }

                        case opMap[100]: { // NEW_FUNC
                            let funcBytecodeId = stack.pop();
                            let funcBytecode = _getBytecode(funcBytecodeId);
                            let isArrowFunc = funcBytecode && funcBytecode[{keyA}];
                            let isAsyncFunc = funcBytecode && funcBytecode[{keyS}];
                            let isGeneratorFunc = funcBytecode && funcBytecode[{keyG}];
                            let closureEnv = env;
                            let syncExec = {vmExecutorName};
                            let asyncExec = {vmAsyncExecutorName};
                            let genExec = {vmGeneratorExecutorName};
                            let funcName = funcBytecode && funcBytecode[{keyNi}] !== undefined ? funcBytecode[{keyC}][funcBytecode[{keyNi}]] : undefined;

                            let closure = (function(closureBytecodeId, capturedEnv, isArrow, isAsync, isGenerator, execSync, execAsync, execGen, funcName) {
                                let createdFunc;
                                let funcBody;
                                if (isGenerator) {
                                    funcBody = function() {
                                        let closureArgs = [];
                                        for (let j = 0; j < arguments.length; j++) {
                                            closureArgs.push(arguments[j]);
                                        }
                                        return execGen.call(this, closureBytecodeId, closureArgs, capturedEnv, createdFunc);
                                    };
                                } else if (isAsync) {
                                    funcBody = async function() {
                                        let closureArgs = [];
                                        for (let j = 0; j < arguments.length; j++) {
                                            closureArgs.push(arguments[j]);
                                        }
                                        let effectiveNewTarget = new.target !== undefined ? new.target : {vmGlobalsName}['__$$newTarget$$__'];
                                        if (isArrow) {
                                            return await execAsync(closureBytecodeId, closureArgs, capturedEnv, createdFunc, undefined);
                                        } else {
                                            return await execAsync.call(this, closureBytecodeId, closureArgs, capturedEnv, createdFunc, effectiveNewTarget);
                                        }
                                    };
                                } else {
                                    funcBody = function() {
                                        let closureArgs = [];
                                        for (let j = 0; j < arguments.length; j++) {
                                            closureArgs.push(arguments[j]);
                                        }
                                        let effectiveNewTarget = new.target !== undefined ? new.target : {vmGlobalsName}['__$$newTarget$$__'];
                                        if (isArrow) {
                                            return execSync(closureBytecodeId, closureArgs, capturedEnv, createdFunc, undefined);
                                        } else {
                                            return execSync.call(this, closureBytecodeId, closureArgs, capturedEnv, createdFunc, effectiveNewTarget);
                                        }
                                    };
                                }
                                createdFunc = funcBody;
                                if (funcName) {
                                    try {
                                        Object.defineProperty(createdFunc, 'name', {
                                            value: funcName,
                                            writable: false,
                                            enumerable: false,
                                            configurable: true
                                        });
                                    } catch (e) {}
                                }
                                return createdFunc;
                            })(funcBytecodeId, closureEnv, isArrowFunc, isAsyncFunc, isGeneratorFunc, syncExec, asyncExec, genExec, funcName);
                            if (!closure) {
                                throw new Error('VM Error: Failed to create closure for bytecode ID ' + funcBytecodeId);
                            }
                            stack.push(closure);
                            pc++;
                            break;
                        }

                        case opMap[104]: { // NEW
                            let argCount = stack.pop();
                            let newArgs = collectArgs(stack, argCount);
                            let ctor = stack.pop();
                            if (typeof ctor !== 'function') {
                                throw new TypeError(ctor + ' is not a constructor');
                            }
                            let instance = Reflect.construct(ctor, newArgs);
                            stack.push(instance);
                            pc++;
                            break;
                        }
    `;
}
